import { ContainerStyle } from "./style"
import LogoHeader from "../../assets/logoHeader.svg"
import SetaBaixo from "../../assets/setaBaixo.svg"
import SetaBaixoClicada from "../../assets/setaBaixoClicada.svg"
import { useEffect, useState } from "react";
import { ReactSVG } from "react-svg";

export const Header = ({scrollToFaixaVerde, scrollToNossosClientes, scrollToCases, scrollToContato}) => {
    const [scrolled, setScrolled] = useState(false);
    const [srcAtual, setSrcAtual] = useState(SetaBaixo);

    useEffect(() => {
      const handleScroll = () => {
        setScrolled(window.scrollY > 0); // se saiu do topo, ativa
      };
  
      window.addEventListener('scroll', handleScroll);
  
      return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    return(
        <ContainerStyle>
            <div className="background-header">
                <div className={`top ${scrolled ? 'scrolled' : ''}`}>
                    <div className="width90">
                    <img src={LogoHeader}/>
                        <div className="div-ancoras">
                            <h4 className="border-right" onClick={() => scrollToFaixaVerde()}>Sobre Nós</h4>
                            <h4 className="border-right" onClick={() => scrollToNossosClientes()}>Clientes</h4>
                            <h4 className="border-right" onClick={() => scrollToCases()}>Cases</h4>
                            <h4 className="contato" onClick={() => scrollToContato()} >Contato</h4>
                        </div>
                    </div>
                </div>
                <div className="div-titulo">
                    <h1>
                        <b>
                            Excelência gráfica
                        </b>
                        com sustentabilidade ecológica.
                    </h1>
                    {/* <img onClick={() => scrollToFaixaVerde()} className="seta-baixo" src={SetaBaixo} /> */}
                    <ReactSVG
                        className="seta-baixo"
                        onClick={() => scrollToFaixaVerde()}
                        src={srcAtual}
                        onMouseEnter={() => setSrcAtual(SetaBaixoClicada)}
                        onMouseLeave={() => setSrcAtual(SetaBaixo)}
                    />
                </div>
            </div>
        </ContainerStyle>
    )
}